
import axios from 'axios'
import ServiceData from "./service"

export default class {
    
    constructor() {
        let service = new ServiceData();
        this.baseURL = service.baseURL;
        this.apiToken = service.apiToken;
    }

    //-----user
    getUser(id) {
        return axios.get(this.baseURL+'users/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        })
    }

    //...///user

    //----businesses
    //get all users businesses
    getBusinesses(id) {
        return axios.get(this.baseURL+'businesses/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        })
    }

    //get business
    getAppBusinessByUserName(id) {
        return axios.get(this.baseURL+'app/businesses/usernames/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        })
    }
    //....///businesses

    //---products
    getAppBusinessProducts(id, limit) {
        return axios.get(this.baseURL + 'products/app/businesses/'+id+'/'+limit, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //get business categories
    getBusinessCategories(id) {
        return axios.get(this.baseURL+'businesses/categories/'+id, {
            headers: {
                'Origin-Host': this.apiToken
            }
        })
    }

    //get category products
    getCategoryProducts(id) {
        return axios.get(this.baseURL + 'products/categories/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }
    //....///products

}


// WEBPACK FOOTER //
// ./src/services/axios_services.js